{
  "identity": {
    "title": "Identidad"
  },
  "status": {
    "title": "Estado"
  },
  "lastUpdate": {
    "title": "Última actualización"
  },
  "profile": {
    "title": "Perfil"
  },
  "group": {
    "title": "Grupo"
  },
  "state": {
    "title": "Estado"
  },
  "name": {
    "title": "Nombre"
  },
  "operations": {
    "title": "Operaciones"
  },
  "connectionParameters": {
    "title": "Parámetros de conexión"
  },
  "specificParameters": {
    "title": "Parámetros específicos"
  },
  "roles": {
    "title": "Permisos"
  }
}
